import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useHistory, useLocation } from 'react-router-dom';
import { closeErrorModal } from '../../actions';
import ModalContainer from './ModalContainer';
import ModalError from './ModalError';
import { useB2CInfo } from '../../hooks';
import { LANDING_URL } from '../../routes';
import { mergeParameters } from '../../util';
import { WRONG_BREED_STATE } from '../../utils/customErrors.utils';

const GenericErrorModalContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { logoutB2C } = useB2CInfo();
  const store = useSelector(({ quoting }) => quoting);
  const { message, parameters, redirectToLanding, utmParams } = store;

  const goToLanding = (prefill = false, extraParams = {}) => {
    if (location.pathname.toLowerCase() !== LANDING_URL) {
      const parametersToUse = {
        ...utmParams,
        EmpId: parameters?.empGuid,
      };
      let query = new URLSearchParams(parametersToUse).toString();

      if (prefill) {
        const paramsToUse = mergeParameters(parameters, extraParams);
        query = new URLSearchParams(paramsToUse);
        if (query.get('empGuid')) {
          query.set('EmpId', query.get('empGuid'));
          query.delete('empGuid');
        }
      }
      const landingUrl = `${LANDING_URL}?${query.toString()}`;

      history.push(landingUrl, {
        focus: true,
      });

      logoutB2C({ logoutUrl: landingUrl });
    }
  };

  const handleErrorModalOutClick = () => {
    dispatch(closeErrorModal());

    if (!parameters?.empGuid) {
      window.location.reload(false);
    }

    goToLanding();
  };

  useEffect(() => {
    if (redirectToLanding && Object.keys(parameters).length) {
      let extraParams = {};
      if (message === WRONG_BREED_STATE) {
        extraParams = {
          petBreed: WRONG_BREED_STATE,
        };
      }
      goToLanding(true, extraParams);
    }

    // eslint-disable-next-line
  }, [redirectToLanding]);

  return (
    <ModalContainer
      cancellable
      handleOutClick={handleErrorModalOutClick}
      idTitle="genericError"
      show={message}
    >
      <ModalError
        buttonText="Got It"
        onButtonClick={handleErrorModalOutClick}
      />
    </ModalContainer>
  );
};

export default GenericErrorModalContainer;
